/** Routes waar Supabase-sessie direct nodig is (geen idle-defer). */
export const AUTH_IMMEDIATE_PATHS = [
  '/login',
  '/signup',
  '/mijn-strippenkaart',
  '/admin',
  '/agenda',
] as const;

export function needsImmediateAuth(pathname: string): boolean {
  return AUTH_IMMEDIATE_PATHS.some(
    (path) => pathname === path || pathname.startsWith(`${path}/`),
  );
}
